import React, { useState } from 'react'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import Fade from '@mui/material/Fade'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Button, Grid } from '@mui/material'
import ImageBg from 'src/assets/Buy_Policy_Images/MotorFormBg.svg'
import Modal from '@mui/material/Modal'
import Backdrop from '@mui/material/Backdrop'
import QuickPriceTile from 'src/components/BuyPolicy/insuranceScreens/bike/QuickPriceTile'
import ThirdPartyPersonal from 'src/components/BuyPolicy/insuranceScreens/bike/ThridPartyPersonal'
import ThridPartyCheckoutTile from 'src/components/BuyPolicy/insuranceScreens/bike/ThridPartyCheckoutTile'
import BikeInfo from 'src/components/BuyPolicy/insuranceScreens/bike/BikeInfo'
import { POLICY_TYPE_BIKE } from 'src/utils/constants/BuyPolicyBike'
import { thirdPartyPlans } from 'src/utils/constants/Bike'
import ProviderImg from 'src/assets/Buy_Policy_Images/digitVector.svg'

const ExpressBuyModal = (props) => {
  const classes = useStyles()
  const { open, setOpen } = props
  const [selectedContainer, setSelectedContainer] = useState(
    POLICY_TYPE_BIKE?.THIRD_PARTY
  )
  const [isPersonal, setIsPersonal] = useState(false)
  const [, setIsActiveSection] = useState(false)
  const [selectedTile, setSelectedTile] = useState(null)

  const handleTileClick = (index) => {
    setSelectedTile(index)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleContainerSelect = (container) => {
    setSelectedContainer(container)
  }

  const handlePersonalFormOpen = () => {
    setIsPersonal(true)
  }

  return (
    <>
      <Modal
        aria-labelledby='transition-modal-expressBuy'
        aria-describedby='transition-modal-description-expressBuy'
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box className={classes.expressBuyContainer}>
            <Box className={classes.expressBuySectionMain}>
              <Box className={classes.expressBuySectionTabs}>
                {isPersonal ? (
                  <Box>
                    <ThirdPartyPersonal setIsPersonal={setIsPersonal} />
                  </Box>
                ) : (
                  <Box className={classes.expressBuyThridParty}>
                    <Box>
                      <Box className={classes.expressBuyTabsHeading}>
                        We&apos;ve retrieved your vehicle details.
                      </Box>
                      <Box className={classes.expressBuyTabsSubHeading}>
                        Choose a third-party plan and secure your insurance
                        today
                      </Box>
                    </Box>
                    <Box className={classes.expressBuyTabs}>
                      <Box className={classes.switchContainer}>
                        <Box className={classes.switchContainerMain}>
                          <Box
                            className={`${classes.insuranceCategoryContainer} ${
                              selectedContainer ===
                              POLICY_TYPE_BIKE?.THIRD_PARTY
                                ? classes.selected
                                : classes.notSelected
                            }`}
                            onClick={() =>
                              handleContainerSelect(
                                POLICY_TYPE_BIKE?.THIRD_PARTY
                              )
                            }
                            id='thirdParty-tab'
                          >
                            <Box className={classes.thirdPartyText}>
                              Third party only cover
                            </Box>
                          </Box>
                          <Box
                            className={`${classes.insuranceCategoryContainer} ${
                              selectedContainer ===
                              POLICY_TYPE_BIKE?.COMPREHENSIVE
                                ? classes.selected
                                : classes.notSelected
                            }`}
                            onClick={() =>
                              handleContainerSelect(
                                POLICY_TYPE_BIKE?.COMPREHENSIVE
                              )
                            }
                            id='comprehensive-tab'
                          >
                            <Box className={classes.comprehensiveText}>
                              OD & Comprehensive cover
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box>
                      <Grid
                        container
                        spacing={{ xs: 1, md: 2 }}
                        columns={{ xs: 4, sm: 8, md: 12 }}
                      >
                        {thirdPartyPlans?.map((item, index) => {
                          const isSelected = selectedTile == index
                          return (
                            <Grid item xs={2} sm={4} md={4} key={item?.price}>
                              <QuickPriceTile
                                id='priceTile'
                                logo={item?.logo}
                                price={item?.price}
                                isSelected={isSelected}
                                onClick={() => handleTileClick(index)}
                              />
                            </Grid>
                          )
                        })}
                      </Grid>
                    </Box>
                    <Box className={classes.expressBuyProceedBtnContainer}>
                      <Button
                        className={classes.expressBuyProceedBtn}
                        variant='contained'
                        onClick={handlePersonalFormOpen}
                      >
                        Proceed
                      </Button>
                    </Box>
                  </Box>
                )}
              </Box>
              <Box className={classes.expressBuySectionDetails}>
                <Box>
                  <Box className={classes.expressBuySectionTwoCloseIcon}>
                    <IconButton onClick={handleClose}>
                      <CloseIcon />
                    </IconButton>
                  </Box>
                </Box>

                <Box>
                  <BikeInfo
                    logo={ProviderImg}
                    setIsActiveSection={setIsActiveSection}
                  />
                </Box>

                {!isPersonal && (
                  <Box className={classes.stepperContainer}>
                    <Box className={classes.stepperHeading}>
                      Get insured in 1 Minute:
                    </Box>

                    <Box>
                      <Box className={classes.stepsRow}>
                        1.
                        <Box>Choose a plan with your bike details.</Box>
                      </Box>
                      <div className={classes.verticalDottedLine}></div>
                      <Box className={classes.stepsRow}>
                        2.{' '}
                        <Box>
                          Share your email and mobile number for your policy
                          copy.
                        </Box>
                      </Box>
                      <div className={classes.verticalDottedLine}></div>
                      <Box className={classes.stepsRow}>
                        3.{' '}
                        <Box>
                          Pay the premium, including GST, and download your
                          policy.
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                )}
                {!isPersonal && (
                  <Box className={classes.notInRushContainer}>
                    <Box className={classes.notInRushText}>Not in a rush?</Box>
                    <Box>
                      <button
                        className={classes.notInRushBtn}
                        variant='contained'
                      >
                        Explore OD & comprehensive plans
                      </button>
                    </Box>
                  </Box>
                )}
                <Box className={classes.flexCenter}>
                  {isPersonal && <ThridPartyCheckoutTile />}
                </Box>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  )
}

export default ExpressBuyModal

const useStyles = makeStyles({
  expressBuyContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: '#FFFFFF',
    width: '65vw',
  },
  expressBuySectionMain: {
    display: 'flex',
    backgroundImage: `url(${ImageBg})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center bottom',
  },
  expressBuySectionTabs: {
    width: '70%',
  },
  expressBuySectionDetails: {
    width: '30%',
    borderRight: '1px solid #ccc',
    background:
      'linear-gradient(192.92deg, #ABD3E0 -54.34%, rgba(255, 255, 255, 0) 94.64%)',
    display: 'flex',
    flexDirection: 'column',
    gap: 15,
    // padding: '16px',
  },
  expressBuySectionTwoCloseIcon: {
    textAlign: 'right',
    right: '0',
    top: '0',
  },
  expressBuyTabsHeading: {
    fontFamily: 'Roboto',
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '23px',
    letterSpacing: '0em',
    textAlign: 'left',
    color: '#000000',
  },
  expressBuyTabsSubHeading: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 300,
    lineHeight: '16px',
    letterSpacing: '0em',
    textAlign: 'left',
    color: '#969696',
  },
  expressBuyThridParty: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    padding: 20,
  },
  expressBuyTabs: {
    display: 'flex',
    justifyContent: 'center',
  },
  switchContainer: {
    backgroundColor: '#E7F5FB',
    borderRadius: 10,
    maxWidth: '360px',
  },
  switchContainerMain: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '3px',
    padding: '5px',
  },

  insuranceCategoryContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 5,
    padding: '0px 10px 0px 10px',
    cursor: 'pointer',
    height: '30px',
    color: '#2BA6C8',
  },

  thirdPartyText: {
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 400,
    lineHeight: '13px',
    letterSpacing: '0em',
    textAlign: 'center',
    // color: '#2BA6C8',
  },
  comprehensiveText: {
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 400,
    lineHeight: '13px',
    letterSpacing: '0em',
    textAlign: 'center',
  },
  selected: {
    backgroundColor: 'white',
    borderRadius: 10,
    boxShadow: '0px 4px 4px 0px #00000033',
    color: '#464646',
  },
  notSelected: {},
  expressBuyProceedBtnContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  expressBuyProceedBtn: {
    width: '153px',
    height: '37px',
    borderRadius: '5px',
    border: '1px',
    background: 'linear-gradient(180deg, #4DC3E3 0%, #1EA0C4 100%)',
    boxShadow: '0px 5px 8px 0px #4DC3E359',
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0em',
    textAlign: 'center',
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  verticalDottedLine: {
    borderLeft: '1.8px dotted #000000',
    height: '20px',
    marginLeft: '3px',
    marginBottom: '4px',
  },
  stepperContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },
  stepperHeading: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 600,
    lineHeight: '15px',
    letterSpacing: '0em',
    color: '#000000',
  },
  stepsRow: {
    display: 'flex',
    flexDirection: 'row',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '14px',
    letterSpacing: '0em',
    color: '#000000',
    maxWidth: '190px',
  },
  notInRushContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 7,
  },
  notInRushText: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '14px',
    letterSpacing: '0em',
    color: '#000000',
  },
  notInRushBtn: {
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 400,
    lineHeight: '13px',
    letterSpacing: '0em',
    color: '#000000',
    border: '1px solid #34C0E5',
    boxShadow: '0px 5px 8px 0px #4DC3E359',
    backgroundColor: '#FFFFFF',
    maxWidth: '207px',
    height: '33px',
    borderRadius: '5px',
  },
  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
  },
})
